import { Card, CardProps } from '@servicetitan/anvil2';
import classNames from 'classnames';
import { FC, PropsWithChildren } from 'react';

import * as Styles from './message-card.module.scss';

export interface MessageCardProps extends CardProps {
    className?: string;
}

export const MessageCard: FC<PropsWithChildren<MessageCardProps>> = ({
    className,
    children,
    ...rest
}) => {
    return (
        <Card className={classNames(Styles.messageCard, className)} {...rest}>
            {children}
        </Card>
    );
};
